import { render, staticRenderFns } from "./SpinPreview.vue?vue&type=template&id=5ed6c085&scoped=true&"
import script from "./SpinPreview.vue?vue&type=script&lang=js&"
export * from "./SpinPreview.vue?vue&type=script&lang=js&"
import style0 from "./SpinPreview.vue?vue&type=style&index=0&id=5ed6c085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6c085",
  null
  
)

export default component.exports